import PanelSearch, { PanelSearchProps as _PanelSearchProps } from './PanelSearch';
// type import/export workaround to prevent TS "export 'foo' was not found in 'bar'" console warning
export default PanelSearch;
export type PanelSearchProps = _PanelSearchProps;
